<template>
  <section>
    <div id="production" class="pd70">
      <div class="wrapper">
        <UiAnim tag="h2" class="block_title">Этапы производства</UiAnim>

        <ol id="production_line">
          <li v-for="(li, i) in list" :key="i">
            <UiAnim tag="span" class="number" type="lr-100">{{ i + 1 }}</UiAnim>
            <div class="production_line_text">
              <UiAnim tag="h3" type="rl-100">{{ li.title }}</UiAnim>
              <UiAnim tag="p">{{ li.text }}</UiAnim>
              <UiAnim tag="p" v-if="li.action" class="action">{{
                li.action
              }}</UiAnim>
              <div class="production-gallery">
                <UiAnim v-for="n in 3" :key="n" :delay="n">
                  <UiLazyImg
                    :wrapAttr="{
                      href: `/static/image/production/${i + 1}-${n}.jpg`,
                    }"
                    tag="a"
                    :src="`/static/image/production/${i + 1}-${n}m.jpg`"
                    @click.prevent="openGallery(i + 1, n)"
                  />
                </UiAnim>
                <UiAnim :delay="4">
                  <UiLazyImg
                    :wrapAttr="{
                      href: `https://www.youtube.com/watch?v=${li.video}`,
                      class: 'video',
                    }"
                    tag="a"
                    :src="`https://img.youtube.com/vi/${li.video}/mqdefault.jpg`"
                    @click.prevent="showYoutube(li.video)"
                  />
                </UiAnim>
                <span class="clr"></span>
              </div>
            </div>
          </li>
        </ol>
      </div>
    </div>
  </section>
  <ModalYoutube :src="youtube" v-if="youtube" @closed="youtube = null" />
  <ModalSwiperGallery
    :data="galData"
    :current="current"
    v-if="current >= 0"
    @closed="current = -1"
  />
</template>

<script setup>
const { isModal, setData, getData, mYoutube } = useModal();
const youtube = ref();
const current = ref(-1);
const galData = ref();
const list = [
  {
    title: "Разбор фары",
    text: "Один из самых ответственных моментов это разборка фары, для хорошего результата необходимо две вещи: качественное оборудование и опытный мастер. Умеем разбирать не разборные фары с помощью специальной химии. Используем специализированное оборудование для пайки пластика фар.",
    video: "YqBHsr79ZzM",
  },
  {
    title: "Установка линзы",
    text: 'К данному этапу мы готовы заранее, к каждому автомобилю у нас имеется "переходная рамка" изготовленная на точнейших лазерных станках. Каким бы ни был сложный механизм, у нас найдется для него решение, которое сохранит штатные функции фар.',
    video: "NDvvc0NJciY",
  },
  {
    title: "Регулировка фары",
    text: "Не стоит переживать за то, что после установки линз вы будете слепить встречный автомобиль, так как все модули будут отрегулированны по ГОСтУ специализированным прибором.",
    action: "Регулировка фар бесплатная!",
    video: "VL0J6r5JbNg",
  },
  {
    title: "Полировка фары",
    text: "После всех работ, мы обязательно работаем над прозрачностью стекол, полировка неотъемлемая часть доработки оптики на автомобиле.",
    action: "Полировка фар входит в комплекс услуг!",
    video: "xBCJGOyPZq0",
  },
  {
    title: "Бронирование фары",
    text: "Мы рекомендуем нашим клиентам наклеивать защитную пленку на оптику для того чтобы не было проникновения ультрафиолета и пескоструя. Тем самым решается проблема желтения фар и обеспечивается защита от внешних физических повреждений.",
    action: "На бронирование фар скидка 30%!",
    video: "lZOHxAsGVIQ",
  },
];
const openGallery = async (i, n) => {
  if (!isModal) return setData("production-" + i, { index: n - 1 });

  const data = await getData("production-" + i);
  galData.value = data.images;
  current.value = n - 1;
};
const showYoutube = (src) => {
  if (!isModal) return mYoutube(src);
  youtube.value = src;
};
</script>
